import script from "./BodorNext15.vue?vue&type=script&setup=true&lang=js"
export * from "./BodorNext15.vue?vue&type=script&setup=true&lang=js"

import "./BodorNext15.vue?vue&type=style&index=0&id=478678bc&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/.store/vue-loader@17.4.2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-478678bc"]])

export default __exports__